// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SvSD","colBig":"styles_colBig__1jZJ8","colSmall":"styles_colSmall__207Cc","shopifyNameWrapper":"styles_shopifyNameWrapper__2BBvY"};